if (!customElements.get('fere-ring-custom-size')) {
  const remembered = new Map();
  customElements.define('fere-ring-custom-size', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.select = this.querySelector('[name="properties[Ring Size]"]');
      this.input = this.querySelector('[data-fere-custom-size-input]');
      this.details = this.querySelector('[data-fere-custom-size-details]');
      if (!this.select || !this.input || !this.details) return;
      this.key = this.dataset.productHandle;
      const saved = remembered.get(this.key);
      if (saved) {
        this.input.value = saved.custom;
        if (saved.size && [...this.select.options].some((option) => option.value === saved.size)) this.select.value = saved.size;
      }
      this.onSelect = (event) => {
        if (event.fereCustomSizeSync) return;
        this.sync();
      };
      this.onInput = () => this.sync();
      this.select.addEventListener('change', this.onSelect);
      this.input.addEventListener('input', this.onInput);
      this.input.addEventListener('change', this.onInput);
      this.sync();
    }

    disconnectedCallback() {
      this.select?.removeEventListener('change', this.onSelect);
      this.input?.removeEventListener('input', this.onInput);
      this.input?.removeEventListener('change', this.onInput);
      this.ready = false;
    }

    sync() {
      const custom = this.select.value === 'Custom size';
      this.details.hidden = !custom;
      this.input.disabled = !custom;
      this.input.required = custom;
      const invalid = custom && !this.input.value.trim();
      this.input.setCustomValidity(invalid ? 'Enter your ring size and sizing system.' : '');
      this.select.setCustomValidity(invalid ? 'Enter your custom ring size below.' : '');
      remembered.set(this.key, { size: this.select.value, custom: this.input.value });
      const event = new Event('change', { bubbles: true });
      event.fereCustomSizeSync = true;
      this.select.dispatchEvent(event);
    }
  });
}
